

















import { Component, Mixins, Prop } from "vue-property-decorator";
import TabSelector from "../../../components/system/selectors/TabSelector.vue";
import ReferenceCommentListTable from "../../../components/workflow/lists/tables/ReferenceCommentListTable.vue";
import { IReferenceCommentListTableCondition } from "../lists/tables/IReferenceCommentListTableCondition";

@Component({
  components: {
    TabSelector,
    ReferenceCommentListTable,
  }
})
export default class ReferenceCommentListTabSelector extends Mixins() {
  @Prop()
  referenceCondition: IReferenceCommentListTableCondition;

  readonly commentTab: any = ReferenceCommentListTabSelector.Tabs.comment;
  static readonly Tabs: {[key: string]: any} = {
    comment: {
      name: "コメント",
      description: "",
    },
  };

  data(): any {
    return {
      tabs: [ReferenceCommentListTabSelector.Tabs.comment],
      selectedTab: null as { name: string, description: string },
    };
  }
  tabs: { name: string, description: string }[];
  selectedTab: { name: string, description: string };

  mounted() {
    this.selectedTab = (this.hasNextMessages || this.hasBackMessages)
      ? this.commentTab
      : null as { name: string, description: string };
  }

  get shouldShowReferenceCommentListTable(): boolean {
    return this.selectedTab && this.selectedTab.name === this.commentTab.name;
  }

  get hasNextMessages(): boolean {
    return this.referenceCondition
      && this.referenceCondition.comments
      && this.referenceCondition.comments.nextMessages
      && this.referenceCondition.comments.nextMessages.comments
      && this.referenceCondition.comments.nextMessages.comments.length > 0;
  }

  get hasBackMessages(): boolean {
    return this.referenceCondition
      && this.referenceCondition.comments
      && this.referenceCondition.comments.backMessages
      && this.referenceCondition.comments.backMessages.comments
      && this.referenceCondition.comments.backMessages.comments.length > 0;
  }
}
